import { module } from 'angular';
import UIMenuComponent from './menu/menu.component';
import subMenuDirective from './menu/sub-menu.directive';

export default module('app')
	.component('uiMenu', UIMenuComponent)
	.directive('subMenu', subMenuDirective);
